import { z } from 'zod';
import { EmailSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema, } from './shared.js';
export const NotificationSchema = z.object({
    id: IDSchema,
    type: z.literal('notification'),
    schemaVersion: SchemaVersionSchema,
    userEmail: EmailSchema,
    eventType: z.string(),
    payload: z.record(z.unknown()),
    correlationId: z.string(),
    createdAt: IsoTimestampSchema,
    readAt: IsoTimestampSchema.nullable().optional(),
    dismissedAt: IsoTimestampSchema.nullable().optional(),
    expiresAt: IsoTimestampSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=notification.js.map